import React from "react";
import styled from "styled-components";
import H1 from "../H1/H1";
import isMobile from "ismobilejs";
const Title = styled.div`
  width: ${(props) => (props.hero ? "70%" : "100%")};
  > * {
    color: ${(props) => (props.white ? "white" : "black")};
  }
  span {
    opacity: 0.18 !important;
  }
`;

function PrettyTitle({ main, sub, white, hero, onClick }) {
  return (
    <Title white={white} hero={hero}>
      {!isMobile().phone ? (
        <H1 onClick={() => (onClick ? onClick() : null)}>
          {main} &nbsp; - &nbsp; <span>{sub}</span>
        </H1>
      ) : (
        <H1 onClick={() => (onClick ? onClick() : null)}>{main}</H1>
      )}
    </Title>
  );
}

export default PrettyTitle;
